export default [
  {
    path: 'assessments',
    component: () => import('@/App.vue'),
    meta: {
      title: 'Assessments',
      sort: 6,
      authenticatable: true,
      icon: 'mdi-flask',
    },
    children: [
      {
        path: '',
        props: true,
        name: 'assessments.index',
        component: () => import('../Index.vue'),
        meta: {
          title: 'Assessment',
          sort: 6,
          authenticatable: true,
          icon: 'mdi-flask'
        },
      },
    ],
  }
]
